import { render, staticRenderFns } from "./ApplyForPermitStarter.vue?vue&type=template&id=0d57bf4a&scoped=true&"
import script from "./ApplyForPermitStarter.vue?vue&type=script&lang=js&"
export * from "./ApplyForPermitStarter.vue?vue&type=script&lang=js&"
import style0 from "./ApplyForPermitStarter.vue?vue&type=style&index=0&id=0d57bf4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d57bf4a",
  null
  
)

export default component.exports